<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">业务基础信息管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>事项管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="left">
        <div class="title">事项类型</div>
        <div class="search-box">
          <el-input
            style="margin-right: 12px"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="sxlx"
          >
          </el-input>
          <el-button
            style="
              width: 40px;
              height: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            @click="openDialog({})"
            class="search el-icon-plus"
          ></el-button>
        </div>
        <div class="type-list">
          <div
            class="type-list-item"
            :class="{ active: ghEventTypeId == item.id }"
            v-for="(item, index) in typeList"
            :key="index"
            @click="typeChange(item)"
          >
            <div class="item-top">
              <div class="name">{{ item.sxlx }}</div>
              <div class="type">{{ item.superFlagName || item.superFlag }}</div>
            </div>
            <div class="item-bottom">
              <div style="color: #909399">{{ item.tjDeptName }}</div>
              <div class="edit">
                <el-button
                  @click="openDialog(item)"
                  icon="el-icon-edit"
                  type="text"
                  v-if="
                    ghEventTypeId == item.id &&
                      item.superFlag == 'EVENT_TYPE_TYPE_FRC'
                  "
                  >编辑</el-button
                >
                <el-button
                  style="color: #eb3538"
                  @click="delEventTypeFun(item)"
                  icon="el-icon-delete"
                  type="text"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">事项列表</div>
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="事项名称">
                  <el-input
                    v-model="form.sxmc"
                    clearable
                    placeholder="请输入事项名称"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否应急事项">
                  <el-select
                    filterable
                    placeholder="是否应急事项"
                    clearable
                    v-model="form.sfyjsx"
                  >
                    <el-option
                      v-for="item in sfyjsxOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="应用状态">
                  <el-select
                    filterable
                    placeholder="应用状态"
                    clearable
                    v-model="form.state"
                  >
                    <el-option
                      v-for="item in sfyjsxOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn">
              <div class="select-number">
                当前选中
                <span style="color: #0090ff">{{
                  selectedIdOptions.length
                }}</span>
                条
              </div>
              <el-button
                icon="el-icon-delete"
                class="delbtn"
                type="text"
                @click="delBatchEventEditFun"
                >批量删除</el-button
              >
            </div>
            <div class="right-btn">
              <!-- <el-button class="other el-icon-download" @click="downloadFileFun"
                >模板下载</el-button
              >
              <el-upload
                class="upload-demo"
                accept=".xlsx"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="importDataFun"
              >
                <el-button class="other el-icon-upload2">数据导入</el-button>
              </el-upload> -->

              <el-button
                @click="openIssuesDialogFun()"
                class="search el-icon-plus"
                >新增</el-button
              >
            </div>
          </div>
          <common-table
            :select="true"
            :maxHeight="460"
            :page="page"
            :dataList="dataList"
            :selectedIdOptions="selectedIdOptions"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            @handleSelectionChange="handleSelectionChange"
            @selectAll="selectAll"
          >
            <template v-slot:extendReportState="{ scope }">
              <el-switch
                @change="
                  value => {
                    changeReportStateFun(value, scope.row.id);
                  }
                "
                v-model="scope.row.extendReportState"
                active-value="是"
                inactive-value="否"
                active-color="#0495FF"
              >
              </el-switch>
            </template>
            <template v-slot:state="{ scope }">
              <el-switch
                @change="
                  value => {
                    eventChangeStateFun(value, scope.row.id);
                  }
                "
                v-model="scope.row.state"
                active-value="是"
                inactive-value="否"
                active-color="#0495FF"
              >
              </el-switch>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="openIssuesDialogFun(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >基本信息</el-button
              >
              <el-button
                v-if="curTypeItem.superFlagName !== '非日常巡查上报'"
                @click="goToSxbz(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >事项标准管理</el-button
              >
              <el-button
                @click="openRuleDialogFun(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >初始规则</el-button
              >
              <el-button
                @click="delEventEditFun(scope.row.id)"
                style="color: #eb3538; font-size: 16px"
                type="text"
                >删除</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <typeDialog
      v-if="dialogVisible"
      @refreshList="selListFun"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </typeDialog>
    <ruleSettingDialog
      v-if="ruleDialogVisible"
      @refreshList="eventPageFun"
      :dialogVisible.sync="ruleDialogVisible"
      :curItem="ruleCurItem"
      :type="1"
    >
    </ruleSettingDialog>
    <issuesDialog
      v-if="issuesDialogVisible"
      @refreshList="eventPageFun"
      :dialogVisible.sync="issuesDialogVisible"
      :curItem="issuesCurItem"
      :typeList="typeList"
    >
    </issuesDialog>
  </div>
</template>
<script>
import {
  selList,
  changeState,
  mangerPonitRelPage,
  eventPage,
  eventChangeState,
  delBatchEventEdit,
  delEventEdit,
  delEventType,
  changeReportState
} from "@/api/base.js";
// import { downloadFile } from "@/api/systemManagement.js";
import commonTable from "@/components/table/index.vue";
import typeDialog from "./components/typeDialog.vue";
import ruleSettingDialog from "./components/ruleSettingDialog.vue";
import issuesDialog from "./components/issuesDialog.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
export default {
  components: {
    commonTable,
    typeDialog,
    ruleSettingDialog,
    issuesDialog
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      curTypeItem: {},
      sxlx: "",
      form: {
        sxmc: "",
        sfyjsx: "",
        state: ""
      },
      sfyjsxOptions: [
        {
          label: "是",
          value: "是"
        },
        {
          label: "否",
          value: "否"
        }
      ],
      dialogVisible: false,
      ruleDialogVisible: false,
      issuesDialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      columns1: [
        {
          prop: "ghEventTypeName",
          label: "事项类型"
        },
        {
          prop: "sxmc",
          label: "事项名称"
        },
        {
          prop: "ghEventTypeSfyjsx",
          label: "是否应急事项"
        },
        {
          prop: "createTime",
          label: "创建时间"
        },
        {
          prop: "createUsername",
          label: "创建人"
        },
        {
          slot: "extendReportState",
          label: "上报案件事项开关"
        },
        {
          slot: "state",
          label: "是否启用"
        },
        {
          slot: "operation",
          label: "操作",
          showToolitip: '1',
          width: 360
        }
      ],
      columns2: [
        {
          prop: "ghEventTypeName",
          label: "事项类型"
        },
        {
          prop: "sxmc",
          label: "事项名称"
        },
        {
          prop: "ghEventTypeSfyjsx",
          label: "是否应急事项"
        },
        {
          prop: "createTime",
          label: "创建时间"
        },
        {
          prop: "createUsername",
          label: "创建人"
        },
        {
          slot: "state",
          label: "是否启用"
        },
        {
          slot: "operation",
          label: "操作",
          showToolitip: '1',
          width: 360
        }
      ],
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "ghEventTypeName",
            label: "事项类型"
          },
          {
            prop: "sxmc",
            label: "事项名称"
          },
          {
            prop: "ghEventTypeSfyjsx",
            label: "是否应急事项"
          },
          {
            prop: "createTime",
            label: "创建时间"
          },
          {
            prop: "createUsername",
            label: "创建人"
          },
          {
            slot: "extendReportState",
            label: "上报案件事项开关"
          },
          {
            slot: "state",
            label: "是否启用"
          },
          {
            slot: "operation",
            label: "操作",
            showToolitip: '1',
            width: 360
          }
        ]
      },
      curItem: {},
      ruleCurItem: {},
      issuesCurItem: {},
      typeList: [],
      ghEventTypeId: null
    };
  },
  mounted() {
    this.selListFun();
  },
  methods: {
    //删除单条事项目录类型
    delEventTypeFun(item) {
      this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await delEventType({
            id: item.id
          });
          if (res.data.code == 200) {
            this.selListFun();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    goToSxbz(item) {
      this.$router.push({
        path: `/issuesStandardManagement`,
        query: {
          ...item
        }
      });
    },
    typeChange(item) {
      this.ghEventTypeId = item.id;
      if (item.superFlag == 'EVENT_TYPE_TYPE_INFINITE') {
        this.dataList.columns = this.columns1;
      } else {
        this.dataList.columns = this.columns2;
      }
      if (item.superFlagName === "非日常巡查上报") {
        this.dataList.columns = this.dataList.columns.filter(
          col => col.prop !== "ghEventTypeSfyjsx"
        );
      }
      this.curTypeItem = item;
      this.eventPageFun();
    },
    openDialog(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    openRuleDialogFun(item) {
      this.ruleDialogVisible = true;
      this.ruleCurItem = item;
    },
    openIssuesDialogFun(item) {
      this.issuesDialogVisible = true;
      this.issuesCurItem = {
        editType: item ? "edit" : "add",
        ghEventTypeId: this.ghEventTypeId,
        dayTimes: 1,
        extendRangeMetre: null,
        extendLongitude: null,
        extendLatitude: null,
        extendAddress: null,
        ...this.curTypeItem,
        ...item
      };
      if (!item) {
        this.issuesCurItem.id = "";
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.eventPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.eventPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    onReset() {
      this.form.sxmc = "";
      this.form.sfyjsx = "";
      this.form.state = "";
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    async selListFun(sxlx) {
      const res = await selList({ sxlx });
      this.typeList = res.data.data || [];
      this.ghEventTypeId = this.typeList.length ? this.typeList[0].id : "";
      // if (this.ghEventTypeId == "d10c6dde183291179f06113d400f08bb" || this.ghEventTypeId == "id_cq_tongzhan") {
      if (this.typeList.length && this.typeList[0].id && this.typeList[0].superFlag == 'EVENT_TYPE_TYPE_INFINITE') {
        this.dataList.columns = this.columns1;
      } else {
        this.dataList.columns = this.columns2;
      }
      this.eventPageFun();
      if (this.typeList.length > 0) {
        this.typeChange(this.typeList[0]);
      }
    },
    async changeStateFun(value, id) {
      const res = await changeState({
        state: value,
        id: id
      });
      this.selListFun();
    },
    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/templates/部门事项导入模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "部门事项导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importData(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.onSearch();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    async eventChangeStateFun(value, id) {
      const res = await eventChangeState({
        state: value,
        id: id
      });
      this.eventPageFun();
    },
    async changeReportStateFun(value, id) {
      const res = await changeReportState({
        state: value,
        id: id
      });
      this.eventPageFun();
    },
    async delEventEditFun(id) {
      const isok = await this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => true)
        .catch(() => false);
      if (!isok) {
        return;
      }
      const res = await delEventEdit({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.eventPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async delBatchEventEditFun() {
      const res = await delBatchEventEdit({
        ids: this.selectedIdOptions
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.onSearch();
        this.selectedIdOptions = [];
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 分页查询
    async eventPageFun() {
      if (this.typeList.length === 0) {
        return;
      }
      let params = {
        sxmc: this.form.sxmc,
        sfyjsx: this.form.sfyjsx,
        state: this.form.state,
        ghEventTypeId: this.ghEventTypeId,
        page: this.page.page,
        size: this.page.size,
        typeSource: "事项管理"
      };
      const res = await eventPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  },
  watch: {
    sxlx: {
      deep: true,
      handler(sxlx) {
        this.selListFun(sxlx);
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.box-father {
  padding-bottom: 24px;

  .section {
    display: flex;
    padding: 0;

    .left {
      width: 20%;
      height: 100%;
      overflow: auto;
      padding: 28px 24px;
      border-right: 1px solid #e0e0e0;
    }

    .right {
      width: 80%;
      height: 100%;
      padding: 28px 24px;
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
  }
}

.search-box {
  display: flex;
  margin-bottom: 12px;
}

.type-list {
  height: calc(100% - 94px);
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 94px;
    padding: 12px;
    background: #f7faff;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .item-top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        margin: 0 8px 6px 0;
      }

      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
        margin: 0 0 6px 0;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .edit {
        width: 140px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .type-list-item.active {
    border: 1px solid #3caaff;
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/issuesManagement/index.vue